import { path } from './path';
import { Wrapper } from './styled';

export function Icon(props: IconProps) {
    const { name, color = 'primary' } = props;

    return (
        <Wrapper $color={color}>
            <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
            >
                {path[name].map((d, index) => (
                    <path key={index} strokeLinecap="round" strokeLinejoin="round" d={d} />
                ))}
            </svg>
        </Wrapper>
    );
}
